<script setup lang="ts">
import HeaderItem from 'pejer/src/components/HeaderItem.vue'

import DashboardTab from 'pejer/src/components/account/DashboardTab.vue'
import BusinessDashboard from 'pejer/src/components/Dashboards/BusinessDashboard.vue'
import HorizontalLine from 'pejer/src/components/HorizontalLine.vue'
</script>
<template>
  <div class="flex flex-col">
    <div class="flex flex-col gap-4">
      <HeaderItem class="" header="Dashboard"></HeaderItem>

      <DashboardTab />
      <HorizontalLine />
      <BusinessDashboard />
    </div>
  </div>
</template>
